import React from 'react'
import { ErrorUI } from 'components'

const Error404: React.FC = () => {
	return <ErrorUI type="Error404" />
}

export default Error404
